import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconPlus = createSVG({
    children: (jsx("path", { d: "M12 4q.304 0 .517.21a.7.7 0 0 1 .234.541v6.498h6.498a.7.7 0 0 1 .541.234q.21.211.21.517a.8.8 0 0 1-.21.541.74.74 0 0 1-.54.21h-6.498v6.498a.68.68 0 0 1-.234.54.7.7 0 0 1-.516.211.78.78 0 0 1-.541-.21.73.73 0 0 1-.21-.541v-6.498H4.753a.73.73 0 0 1-.54-.21.78.78 0 0 1-.21-.541q0-.304.21-.517a.69.69 0 0 1 .54-.234h6.498V4.751a.73.73 0 0 1 .21-.54.78.78 0 0 1 .541-.21z" })),
});

export { IconPlus };
